import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

const PriceNotes = ({ t }) => (
  <>
    <p className="fe-trip-listing-note">* {t('gen:pricePerPaxNote')}</p>
    {/* <p className="fe-trip-listing-note">** {t('gen:priceByAgeNote')}</p> */}
  </>
);

PriceNotes.propTypes = {
  t: PropTypes.func.isRequired
};

export default withTranslation()(PriceNotes);
